module.exports = __webpack_public_path__ + "media/music_12.ea386ca7.mp3";